/* tslint:disable */

declare var Object: any;
export interface PaydayLoanServiceInterface {
  "id"?: number;
}

export class PaydayLoanService implements PaydayLoanServiceInterface {
  "id": number;
  constructor(data?: PaydayLoanServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PaydayLoanService`.
   */
  public static getModelName() {
    return "PaydayLoanService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PaydayLoanService for dynamic purposes.
  **/
  public static factory(data: PaydayLoanServiceInterface): PaydayLoanService{
    return new PaydayLoanService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PaydayLoanService',
      plural: 'PaydayLoanServices',
      path: 'PaydayLoanServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/PaydayLoanService.ts